export default "__VITE_ASSET__a50e8044__"